import {
  GET_PUBLIC_UPLOADS,
  FETCH_PUBLIC_UPLOAD,
  ADD_PUBLIC_UPLOAD,
  EDIT_PUBLIC_UPLOAD,
  DELETE_PUBLIC_UPLOAD,
  GET_PUBLIC_UPLOADS_BY_CATEGORY,
  CLEAR_PUBLIC_UPLOADS,
  UPDATE_PUBLIC_UPLOAD_PAGE_NUMBER,
  UPDATE_PUBLIC_UPLOAD_QUERY_PARAMS,
  PUBLIC_UPLOADS_PENDING,
} from "constants/actions";

const initialState = {
  publicUploads: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  publicUploadDetail: null,
  publicUploadsByCategory: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  pageNumber: 1,
  queryParams: {},
  loading: false,
  error: null,
};

export default function publicUpload(state = initialState, action) {
  switch (action.type) {
    case PUBLIC_UPLOADS_PENDING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_PUBLIC_UPLOADS:
      return {
        ...state,
        loading: false,
        publicUploads: action.payload,
        error: null,
      };

    case FETCH_PUBLIC_UPLOAD:
      return {
        ...state,
        loading: false,
        publicUploadDetail: action.payload,
        error: null,
      };

    case ADD_PUBLIC_UPLOAD:
      return {
        ...state,
        loading: false,
        publicUploadDetail: action.payload,
        error: null,
      };

    case EDIT_PUBLIC_UPLOAD:
      return {
        ...state,
        loading: false,
        publicUploadDetail: action.payload,
        error: null,
      };

    case DELETE_PUBLIC_UPLOAD:
      return {
        ...state,
        loading: false,
        publicUploadDetail: null,
        error: null,
      };

    case GET_PUBLIC_UPLOADS_BY_CATEGORY:
      return {
        ...state,
        loading: false,
        publicUploadsByCategory: action.payload,
        error: null,
      };

    case UPDATE_PUBLIC_UPLOAD_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: action.payload,
      };

    case UPDATE_PUBLIC_UPLOAD_QUERY_PARAMS:
      return {
        ...state,
        queryParams: action.payload,
      };

    case CLEAR_PUBLIC_UPLOADS:
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
